import { db } from '@/src/tools/db';
import { useLiveQuery } from 'dexie-react-hooks';

function useSaveDraft(
  salesChannelUuid: string,
  contentUuid: string,
  language: string,
  contentPageUuid: string,
) {
  try {
    const primaryKey = `${contentPageUuid}+${contentUuid}`;

    const data = useLiveQuery(async () => {
      const savedDraft = await db.data
        .where('primaryKey')
        .equals(primaryKey)
        .and((data) => {
          return (
            data?.salesChannelUuid === salesChannelUuid &&
            data?.language === language
          );
        })
        .toArray();

      return savedDraft;
    }, [salesChannelUuid, contentUuid, language, contentPageUuid]);

    const handleAddDraft = async (language: string, data: string) => {
      if (data?.length === 0) {
        await db.data.add(
          {
            primaryKey,
            contentPageUuid,
            contentUuid,
            salesChannelUuid,
            language,
            data,
          },
          primaryKey,
        );
      } else {
        await db.data.put(
          {
            primaryKey,
            contentUuid,
            salesChannelUuid,
            contentPageUuid,
            language,
            data,
          },
          primaryKey,
        );
      }
    };

    const handleDeleteDraft = async () => {
      if (data?.length !== 0) {
        await db.data.delete(primaryKey);
      }
    };

    return {
      hasDraft: data?.length !== 0,
      draft: data,
      handleAddDraft,
      handleDeleteDraft,
    };
  } catch (e) {
    console.log('indexDB does not be supported here');
    return {
      hasDraft: false,
      draft: null,
      handleAddDraft: () => {
        return;
      },
      handleDeleteDraft: () => {
        return;
      },
    };
  }
}

export default useSaveDraft;
